
<h2 *ngIf="series">{{series.title}} ({{series.when}})</h2>

<p>
  <button type="button" class="btn btn-sm btn-outline-secondary" (click)="back()"><i class="fa fa-arrow-left"></i> Sorozatok</button>
</p>

<table class="table table-striped">
  <thead>
  <tr>
    <th>Sorszám</th>
    <th>Eőadó</th>
    <th>&nbsp;</th>
  </tr>
  </thead>
  <tbody>
  <tr *ngFor="let l of lectures">
    <td>{{l.number}}</td>
    <td>{{l.preacher}}</td>
    <td>
      <a class="btn btn-sm btn-success"
         href="{{l.file | storageLink:'sessions'}}"
         target="_blank"
      ><i class="fa fa-download"></i> Letöltés</a>
      <button type="button"
              class="btn btn-sm btn-outline-danger"
              (click)="removeLecture(l)"
              *ngIf="auth.hasAnyRoleOf('admin', 'av')"
      ><span class="fa fa-trash"></span><span class="sr-only">Törlés</span></button>
    </td>
  </tr>
  </tbody>
</table>

<div *ngIf="!lectures">Betöltés...</div>

<div *ngIf="series && auth.hasRole('av')">
  <a [routerLink]="['/admin/felvetelek/sorozatok', series.id, 'uj']"
     class="btn btn-outline-primary"
  >
    <span class="fa fa-plus"></span> Hozzáadás
  </a>
</div>



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/sermons/lectures/lectures.component.html